import React, { useEffect } from 'react';
import authService from './AuthService';
import { ApplicationPaths } from './constants';
function Logout() {
    useEffect(function () {
        populateLogoutState();
    }, []);
    var populateLogoutState = function () {
        authService.signOut();
        location.href = "#" + ApplicationPaths.Login;
    };
    return (React.createElement("div", { className: "container" }, "loading..."));
}
export default Logout;
